export const FEATURE_FLAGS = {
  EDIT_LINK_TO_DOCUMENT: 'edit-link-to-document',
  BCF_EXPORT_ENABLED: 'bcf-export',
  MAP_ATTRIBUTES_FROM_CUSTOM_ATTRIBUTES: 'map-attributes-from-custom-attributes',
  FILTER_BY_SUB_TYPE: 'filter-by-sub-type-v2',
  SORT_BY_TYPE_AND_ROOT_CAUSE: 'sort-by-root-cause',
  SORT_BY_TYPE_AND_ROOT_CAUSE_REPORT: 'sort-by-root-cause-report-v2',
  FILTER_ISSUES_BY_ID: 'filter-issues-by-id',
  FILTER_ISSUES_BY_ID_REPORT: 'filter-issue-by-id-report',
  SUPPORT_PROJECT_SCOPE: 'support-project-scope',
  ISSUES_LIST_OPENED_ON_CLOSED_ON_COLUMNS: 'issues-list-opened-on-closed-on-columns',
  DATE_SELECTOR: 'date-selector',
  PROJECT_SETUP_IN_PROGRESS_EMPTY_STATE: 'project-setup-in-progress-empty-state',
  PERMISSIONS_BULK_SELECTION_USE_SELECT_BOX: 'permissions-bulk-selection-use-select-box',
  ATTACHMENTS_V2: 'attachments-v2',
  ENTITY_LINKER_RFI_ATTACHMENTS: 'entity-linker-rfi-attachments',
  FILTER_BY_CUSTOM_ATTRIBUTES: 'filter-by-custom-attributes',
  ISSUES_V2: 'issues-v2',
  CHANGE_ISSUE_TYPE: 'change-issue-type',
  LINK_UNLINK_DOCUMENT: 'link-unlink-document',
  RESTRICT_ISSUE_ASSIGNEE_FIELD: 'restrict-issue-assignee-field',
  ACTIVITIES_V2: 'activities-v2',
  FETCH_DELETED_USERS: 'fetch-deleted-users',
  BIM360_BCF_REPORT: 'BIM360_BCF_REPORT',
  PERMISSIONS_V2: 'permissions-v2',
  DOC_VIEW_PDF_AND_XLSX_EXPORT: 'doc-view-pdf-and-xlsx-export',
  STOP_PUSHPIN_THUMBNAIL_UPLOAD: 'stop-pushpin-thumbnail-upload',
  CHECKLIST_INDICATOR: 'checklist-indicator',
  UPDATE_LOCATION_WITH_PUSHPIN: 'update-location-with-pushpin',
  EXPORT_WITH_CUSTOM_ATTRIBUTES_FILTERS: 'export-with-custom-attributes-filters',
  RESTRICT_CREATE_ISSUE_DISABLE_PROP: 'create-issue-disable-prop',
  USE_ISSUES_BATCH_GET: 'use-issues-batch-get',
  PASS_SHOULD_GENERATE_THUMBNAIL_TO_ISSUES_V2: 'Pass-shouldGenerateThumbnail-To-Issues-V2',
  ALWAYS_EXPORT_CUSTOM_ATTRIBUTES_IN_REPORT: 'always-export-custom-attributes-in-report',
  USE_ISSUES_CLOUDOS_V3_BACKEND: 'use-issues-cloudos-v3-backend',
  UPDATE_DOCUMENT_DETAILS_IN_CREATE_ISSUE: 'update-document-details-in-create-issue',
  SHOW_DISABLE_TEMPLATES_MODAL: 'show-disable-templates-modal',
  REMOVE_CSV_EXPORT: 'remove-csv-export',
  GENERATE_ISSUES_BIM360_REPORT: 'generate-issues-bim-report',
  ADD_USER_ROLES_DETAIL: 'add-user-roles-detail',
  INCREASE_USER_DELETE_API_LIMIT: 'increase-delete-api-limit'
};

export const DEFAULT_FEATURE_FLAGS_VALUES = {
  [FEATURE_FLAGS.EDIT_LINK_TO_DOCUMENT]: false,
  [FEATURE_FLAGS.BCF_EXPORT_ENABLED]: false,
  [FEATURE_FLAGS.MAP_ATTRIBUTES_FROM_CUSTOM_ATTRIBUTES]: false,
  [FEATURE_FLAGS.FILTER_BY_SUB_TYPE]: false,
  [FEATURE_FLAGS.SORT_BY_TYPE_AND_ROOT_CAUSE]: false,
  [FEATURE_FLAGS.SORT_BY_TYPE_AND_ROOT_CAUSE_REPORT]: false,
  [FEATURE_FLAGS.FILTER_ISSUES_BY_ID]: false,
  [FEATURE_FLAGS.FILTER_ISSUES_BY_ID_REPORT]: false,
  [FEATURE_FLAGS.PROJECT_SETUP_IN_PROGRESS_EMPTY_STATE]: false,
  [FEATURE_FLAGS.FETCH_DELETED_USERS]: false,
  [FEATURE_FLAGS.PASS_SHOULD_GENERATE_THUMBNAIL_TO_ISSUES_V2]: false,
  [FEATURE_FLAGS.ISSUES_V2]: true,
  [FEATURE_FLAGS.ALWAYS_EXPORT_CUSTOM_ATTRIBUTES_IN_REPORT]: false,
  [FEATURE_FLAGS.USE_ISSUES_CLOUDOS_V3_BACKEND]: false,
  [FEATURE_FLAGS.UPDATE_DOCUMENT_DETAILS_IN_CREATE_ISSUE]: false,
  [FEATURE_FLAGS.REMOVE_CSV_EXPORT]: false,
  [FEATURE_FLAGS.GENERATE_ISSUES_BIM360_REPORT]: false,
  [FEATURE_FLAGS.ADD_USER_ROLES_DETAIL]: false,
  [FEATURE_FLAGS.INCREASE_USER_DELETE_API_LIMIT]: false
};
